/**
Old deprecated method of downloading data is below return of current version.
**/
import React from "react";
import L, { divIcon } from "leaflet";

import { FeatureLayer } from "react-esri-leaflet";

export default function TruckWeighInspStationsLayer(props) {
  const { layerRef, layerIcon } = props;

  const customMarkerIcon = divIcon({
    html: layerIcon,
  });

  const pointToLayer = (feature, latlng) => {
    let tooltipText = `
    <div>
      <p><strong>Truck Weigh/Inspection Station:</strong> ${feature.properties.Facility_N}</p>
    </div>
    `;
    let popupText = `
    <div>
      <div style="text-align: center;border-bottom: 2.0px solid black;">
        <h3 style="margin-bottom: 0.25rem;margin-top: 0.25rem;">Truck Weigh/Inspection Station</h3>
      </div>
      <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Facility Name:</strong> ${feature.properties.Facility_N}</p>
      <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>ID:</strong> ${feature.properties.ID}</p>
      <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>County Name:</strong> ${feature.properties.County_Nam}</p>
      <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>County Number:</strong> ${feature.properties.County_Num}</p>
      <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Route:</strong> ${feature.properties.Route}</p>
      <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Route ID:</strong> ${feature.properties.Route_ID}</p>
      <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>MilePoint:</strong> ${feature.properties.MilePoint}</p>
      <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Mailing Address:</strong> ${feature.properties.Mailing_Ad}</p>
      <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Phone:</strong> ${feature.properties.Phone}</p>
      <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Fax:</strong> ${feature.properties.Fax}</p>
      <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Garage:</strong> ${feature.properties.Garage}</p>
      <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Parking:</strong> ${feature.properties.Parking}</p>
      <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Spaces:</strong> ${feature.properties.Spaces}</p>
      <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Time:</strong> ${feature.properties.Time}</p>
      <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Agency:</strong> ${feature.properties.Agency}</p>
      <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Officer:</strong> ${feature.properties.Officer}</p>
      <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>LOC_ERROR:</strong> ${feature.properties.LOC_ERROR}</p>
    </div>
    `;
    return L.marker(latlng, {
      icon: customMarkerIcon,
    })
      .bindTooltip(tooltipText)
      .bindPopup(popupText);
  };

  return (
    <FeatureLayer
      ref={layerRef}
      // where={`CITY = ${city}`}
      url="https://services.arcgis.com/njFNhDsUCentVYJW/ArcGIS/rest/services/SHA_Truck_Weigh_Inspection_Stations_2009/FeatureServer/0"
      // eventHandlers={{
      //   loading: () => {
      //     console.log("featurelayer loading");
      //   },
      //   load: () => {
      //     console.log("featurelayer loaded");
      //     if (layerRef && layerRef.current) {
      //       layerRef.current.metadata((error, data) => {
      //         console.log("featurelayer metadata:", data);
      //       });
      //     }
      //   },
      // }}
      pointToLayer={pointToLayer}
    />
  );
}

/**
Old deprecated method is below.
**/
// import React, { useState, useEffect, useContext } from "react";
// import axios from "axios";
// import { GeoJSON, LayerGroup } from "react-leaflet";
// import L from "leaflet";
// // import { QueryContext } from "../QueryContext";
// import { useGlobalState, useGlobalUpdater } from "../../common/GlobalContext";
// import Icon from "@material-ui/core/Icon";
// import { renderToStaticMarkup } from "react-dom/server";
// import { divIcon } from "leaflet";
// import { makeStyles } from "@material-ui/core/styles";

// const useStyles = makeStyles((theme) => ({
//   icon: {
//     backgroundColor: "#CBC3E3",
//     width: "1.25rem",
//     height: "1.25rem",
//     display: "block",
//     left: "-0.25rem",
//     top: "-0.25rem",
//     position: "relative",
//     // borderRadius: "3rem 3rem 0",
//     // transform: "rotate(45deg)",
//     // border: "1px solid #FFFFFF",
//   },
// }));

// export default function TruckWeighInspStationsLayer(props) {
//   // const [query, dispatch] = useContext(QueryContext);
//   const query = useGlobalState();
//   const dispatch = useGlobalUpdater();
//   const classes = useStyles();

//   const iconMarkup = renderToStaticMarkup(
//     <span className={classes.icon}>
//       <Icon fontSize="small" style={{ color: "#000000" }}>
//         local_shipping
//       </Icon>
//     </span>
//   );
//   const customMarkerIcon = divIcon({
//     html: iconMarkup,
//   });

//   const [featuresData, setFeaturesData] = useState({
//     type: "FeatureCollection",
//     features: [],
//   });

//   useEffect(() => {
//     if (query.truckWeighInspStationsFeatures.features.length === 0) {
//       const fetchMapData = async () => {
//         try {
//           if (featuresData.features.length === 0) {
//             let url =
//               "https://services.arcgis.com/njFNhDsUCentVYJW/ArcGIS/rest/services/SHA_Truck_Weigh_Inspection_Stations_2009/FeatureServer/0/query?where=FID+%3E%3D+0&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&resultType=none&distance=0.0&units=esriSRUnit_Meter&returnGeodetic=false&outFields=FID%2CID%2CCounty_Nam%2CFacility_N%2CCounty_Num%2CRoute%2CRoute_ID%2CMilePoint%2CMailing_Ad%2CPhone%2CFax%2CGarage%2CParking%2CSpaces%2CTime%2CAgency%2COfficer%2CLOC_ERROR&returnGeometry=true&featureEncoding=esriDefault&multipatchOption=xyFootprint&maxAllowableOffset=&geometryPrecision=&outSR=&datumTransformation=&applyVCSProjection=false&returnIdsOnly=false&returnUniqueIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&returnQueryGeometry=false&returnDistinctValues=false&cacheHint=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&having=&resultOffset=&resultRecordCount=&returnZ=false&returnM=false&returnExceededLimitFeatures=true&quantizationParameters=&sqlFormat=none&f=pgeojson&token=";
//             const response = await axios.get(url);

//             dispatch({
//               type: "setTruckWeighInspStationsFeatures",
//               selection: response.data,
//             });

//             setFeaturesData(response.data);
//           }
//         } catch (e) {
//           console.log(e);
//         }
//       };
//       fetchMapData();
//     } else {
//       setFeaturesData(query.truckWeighInspStationsFeatures);
//     }
//   }, []);

//   const pointToLayer = (feature, latlng) => {
//     let tooltipText = `
//     <div>
//       <p><strong>Truck Weigh/Inspection Station:</strong> ${feature.properties.Facility_N}</p>
//     </div>
//     `;
//     let popupText = `
//     <div>
//       <div style="text-align: center;border-bottom: 2.0px solid black;">
//         <h3 style="margin-bottom: 0.25rem;margin-top: 0.25rem;">Truck Weigh/Inspection Station</h3>
//       </div>
//       <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Facility Name:</strong> ${feature.properties.Facility_N}</p>
//       <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>ID:</strong> ${feature.properties.ID}</p>
//       <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>County Name:</strong> ${feature.properties.County_Nam}</p>
//       <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>County Number:</strong> ${feature.properties.County_Num}</p>
//       <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Route:</strong> ${feature.properties.Route}</p>
//       <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Route ID:</strong> ${feature.properties.Route_ID}</p>
//       <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>MilePoint:</strong> ${feature.properties.MilePoint}</p>
//       <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Mailing Address:</strong> ${feature.properties.Mailing_Ad}</p>
//       <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Phone:</strong> ${feature.properties.Phone}</p>
//       <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Fax:</strong> ${feature.properties.Fax}</p>
//       <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Garage:</strong> ${feature.properties.Garage}</p>
//       <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Parking:</strong> ${feature.properties.Parking}</p>
//       <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Spaces:</strong> ${feature.properties.Spaces}</p>
//       <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Time:</strong> ${feature.properties.Time}</p>
//       <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Agency:</strong> ${feature.properties.Agency}</p>
//       <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>Officer:</strong> ${feature.properties.Officer}</p>
//       <p style="margin-bottom: 0.25rem;margin-top: 0.25rem;"><strong>LOC_ERROR:</strong> ${feature.properties.LOC_ERROR}</p>
//     </div>
//     `;
//     return L.marker(latlng, {
//       icon: customMarkerIcon,
//     })
//       .bindTooltip(tooltipText)
//       .bindPopup(popupText);
//   };

//   return (
//     <LayerGroup>
//       {featuresData.features.length > 0 && (
//         <GeoJSON data={featuresData} pointToLayer={pointToLayer} />
//       )}
//     </LayerGroup>
//   );
// }
